import React, { useImperativeHandle, useRef} from "react";
import {CheckboxProps} from "./Checkbox.types";
import styles from "./Checkbox.module.scss";

const Checkbox = React.forwardRef<
    HTMLInputElement,
    CheckboxProps
>((props, ref) => {

    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => inputRef.current);
    return (
        <button className={styles.Checkbox} data-zoom={props.zoom} disabled={props.disabled} data-testid="Checkbox" onClick={() => inputRef.current.click()}>
            <svg className={styles.checkedIcon} width="14" height="15" viewBox="0 0 14 15" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M3 0.603973C1.34315 0.603973 0 1.94712 0 3.60397V11.604C0 13.2608 1.34315 14.604 3 14.604H11C12.6569 14.604 14 13.2608 14 11.604V3.60397C14 1.94712 12.6569 0.603973 11 0.603973H3ZM5.74627 10.4998C5.53048 10.4988 5.32353 10.4122 5.17107 10.2576L3.50448 8.56513C3.18896 8.24494 3.19391 7.73038 3.51265 7.41597C3.83147 7.10255 4.34682 7.10396 4.66218 7.42449L5.75407 8.53369L9.34189 4.94586C9.65923 4.62852 10.1737 4.62852 10.4911 4.94586C10.8084 5.26321 10.8084 5.77772 10.4911 6.09507L6.32483 10.2613C6.17198 10.4148 5.96474 10.4998 5.75003 10.4998L5.74627 10.4998Z"
                      fill="currentColor"/>
            </svg>
            <svg className={styles.unCheckedIcon} width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="1.10397" width="13" height="13" rx="2.5" stroke="currentColor"/>
            </svg>
            <svg className={styles.indeterminateIcon} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3 0C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H11C12.6569 14 14 12.6569 14 11V3C14 1.34315 12.6569 0 11 0H3ZM9.91665 7.8125H4.08331C3.63467 7.8125 3.27081 7.44864 3.27081 7C3.27081 6.55136 3.63467 6.1875 4.08331 6.1875H9.91665C10.3653 6.1875 10.7291 6.55136 10.7291 7C10.7291 7.44864 10.3653 7.8125 9.91665 7.8125Z" fill="currentColor"/>
            </svg>
            <input ref={inputRef} type="checkbox" hidden {...props}></input>
        </button>
    );
})

Checkbox.displayName = 'Checkbox';

export default Checkbox;